import React, { useState } from "react";

import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRobot,
  faUniversity,
  faUsers,
  faWrench,
  faBookOpen,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ManagementSidebar = ({ index }) => {
  const [openIndex, setOpenIndex] = useState(index || 2);
  const navigate = useNavigate();
  const { btncolor, brokerMarkets } = useSelector((state) => state);

  console.log("openIndex", openIndex);

  const menuItems = [
    {
      text: "Account Management",
      icon: faRobot,
      action: (index) => {
        setOpenIndex(index);
        navigate("/account-management", { state: { openIndex: index } });
      },
    },
    (brokerMarkets === undefined || brokerMarkets?.isAssetMgmt === 1) && {
      text: "Asset Management",
      icon: faUniversity,
      action: (index) => {
        setOpenIndex(index);
        navigate("/asset-management", { state: { openIndex: index } });
      },
    },
    {
      text: "Order Management",
      icon: faUsers,
      action: (index) => {
        setOpenIndex(index);
        navigate("/order-management", { state: { openIndex: index } });
      },
    },
    {
      text: "Transaction History",
      icon: faWrench,
      action: (index) => {
        setOpenIndex(index);
        navigate("/transaction-history", { state: { openIndex: index } });
      },
    },
    {
      text: "Login History",
      icon: faBookOpen,
      action: (index) => {
        setOpenIndex(index);
        navigate("/login-history", { state: { openIndex: index } });
      },
    },
  ].filter(Boolean);
  return (
    <Box
      sx={{
        height: "100%",
        borderRadius: 2,
        boxShadow: 5,
      }}
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => item.action(index + 1)}
              className="menu-item"
              selected={openIndex === index + 1}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: btncolor,
                  color: "#fff",
                  "& .sidebar_icon": {
                    color: "#fff",
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <FontAwesomeIcon icon={item.icon} className="sidebar_icon" />
              </ListItemIcon>
              <ListItemText primary={item.text} className="list-item-text" />
              <div className="chevron">
                {openIndex === index + 1 ? "" : "»"}
              </div>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ManagementSidebar;
